import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { peopleSelectMenuProps } from '../dashboardcomponents/People/peopleSelectStyles';

const buttonStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  color: '#405261',
  border: '1px solid #D5DCE1',
  fontSize: '12px',
  fontWeight: '500',
  borderRadius: '8px',
  padding: '10px 13px',
  width: '100%',
  textTransform: 'none',
  marginTop: '8px',
  background: '#fff',
  boxShadow: '0px 1px 2px 0px rgba(6, 21, 34, 0.05)',
};

const menuItemSx = {
  fontFamily: 'Inter',
  fontSize: 14,
};

function OptionsSelectInput({
  options = [],
  value = '',
  onChange = () => {},
  placeholder = 'Select Option',
  popupIcon,
  name = 'options-select',
  id = 'options-select',
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const selectedOption = options.find((opt) => opt.value === value) || null;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (optionValue) => {
    onChange(optionValue);
    handleClose();
  };

  const menuPaperSx = {
    ...peopleSelectMenuProps.PaperProps.sx,
    maxHeight: 48 * 4.5,
    width: anchorEl ? Math.max(anchorEl.clientWidth, 200) : '37ch',
    textTransform: 'none',
  };

  return (
    <div>
      <Button
        aria-label="more"
        id={id}
        name={name}
        aria-controls={open ? `${id}-menu` : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        style={buttonStyle}
      >
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {selectedOption?.label || placeholder}
        </span>
        {popupIcon}
      </Button>
      <Menu
        id={`${id}-menu`}
        MenuListProps={{
          'aria-labelledby': id,
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: menuPaperSx,
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === value}
            onClick={() => handleMenuItemClick(option.value)}
            className="Select-number"
            sx={menuItemSx}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

OptionsSelectInput.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  popupIcon: PropTypes.node,
  name: PropTypes.string,
  id: PropTypes.string,
};

OptionsSelectInput.defaultProps = {
  options: [],
  value: '',
  onChange: () => {},
  placeholder: 'Select Option',
  popupIcon: null,
  name: 'options-select',
  id: 'options-select',
};

export default OptionsSelectInput;
